var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M5.71436 1H21.4286C22.2622 1 23.0616 1.33112 23.651 1.92052C24.2404 2.50992 24.5715 3.30932 24.5715 4.14286V15.1429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_2",
    d: "M24.5715 23H8.85721C8.02367 23 7.22428 22.6689 6.63488 22.0795C6.04548 21.4901 5.71436 20.6907 5.71436 19.8572V8.85718",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_3",
    d: "M19.8572 10.4286L24.5715 15.1429L29.2857 10.4286",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_4",
    d: "M10.4286 13.5715L5.71428 8.85718L1 13.5715",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.9dd0164fa8fb9d181ac96c0f4d1a9775.svg";
export { ForwardRef as ReactComponent };